import { Command, ICommandResult, CommandResult } from '@/_core/cqrs/types/commands';
import { UserNotificationModel } from '@/store/global/notifications/types';
import { uuid } from '@/_core/utils/uuid';
import { BoardUserActivityType } from '../workspaceSettings/queries';

export enum BoardVisibility {
    Public,
    WorkspaceVisible,
    Private,
}

export interface CollectionModel {
    Id: string;
    Name: string;
    Slug: string;
    LastStorymapActivityAt: Date;
    CreatedAt: Date;
}

export interface MainModelBase {
    WorkspaceName: string;
    UsersWorkspaceCount: number;
    CurrentUserName: string;
    CurrentUserLoginName: string;
}

export interface StorymapCollaboratorModel {
    Id: string;
    UserId: string;
    Name: string;
}

export class CommentModel {
    constructor(
        public id: string,
        public createdBy: string,
        public createdByUserId: string,
        public timeToDisplay: Date,
        public isCurrentUsersComment: boolean,
        public commentText: string,
        public isLastSeenComment: boolean = false,
        public isEdited: boolean = false
    ) {
        this.createdBy = isCurrentUsersComment ? 'You' : createdBy;
    }

    public static async createReplyFromNotification(notification: UserNotificationModel, replyText: string) {
        const id = await uuid.create();
        const comment = new CommentModel(
            id,
            'I',
            initAppData.currentUser.currentUserShortId,
            new Date(),
            true,
            `@[${notification.sourceUserName}](id:${notification.sourceUserId}) ${replyText}`,
            false,
            false
        );

        return comment;
    }
}

export class AddCardCommentCommand extends Command<ICommandResult> {
    public WorkspaceId: number;
    public BoardActivity: any;
    public StoryMapSlug: string;
    public StorymapId: string;

    private constructor(
        public CardId: string,
        public CommentId: string,
        public CommentText: string,
        public RepliedToId: string,
        public MentionedIds: string[],
        public IsEverybodyMentioned: boolean,
        public CreatorUserName: string,
        public CreatorUserId: string
    ) {
        super('AddCardComment');
    }

    public static async create(
        cardId: string,
        cardName: string,
        comment: CommentModel,
        repliedToId: string,
        mentionedUserIds: string[],
        storymapId: string,
        storymapSlug: string,
        workspaceId: number
    ) {
        const cmd = new AddCardCommentCommand(
            cardId,
            comment.id,
            comment.commentText,
            repliedToId,
            mentionedUserIds,
            mentionedUserIds.includes('EVERYBODY'),
            initAppData.currentUser.currentUserFullName,
            initAppData.currentUser.currentUserId
        );

        cmd.StorymapId = storymapId;
        cmd.StoryMapSlug = storymapSlug;
        cmd.WorkspaceId = workspaceId;

        const activityId = await uuid.create();

        const activity = {
            CardDescription: '',
            CardId: cardId,
            CardName: cardName,
            Content: comment.commentText,
            Datetime: new Date().toJSON(),
            EstimationUnit: '',
            Id: activityId,
            StorymapId: storymapId,
            WorkspaceId: workspaceId,
            Type: BoardUserActivityType.CardCommentAdded,
            UserId: initAppData.currentUser.currentUserId,
            Username: initAppData.currentUser.currentUserFullName,
        };

        cmd.BoardActivity = activity;
        return cmd;
    }
}

export class SendUserFeedback extends Command<CommandResult> {
    constructor(public Feature: string, public Rating: string, public Message: string, public ForceNewEntry: boolean = false) {
        super('SendUserFeedback');
    }
}

export class LogAcceptAiCompletion extends Command<CommandResult> {
    constructor(public Id: string) {
        super('LogAcceptAiCompletion');
    }
}

export class LogCancelFeedbackAiCompletion extends Command<CommandResult> {
    constructor(public Id: string, public PromptText: string, public CompletionText: string) {
        super('LogCancelFeedbackAiCompletion');
    }
}
